export const Colors = {
  background: '#050914',
  surface: '#0c1220',
  surfaceAlt: '#080d18',
  border: '#1a2435',

  text: '#f5f7fb',
  textSecondary: '#a9b3c7',
  textMuted: '#667085',

  futebol: '#52ff27',
  futeboLight: '#27d915',
  nba: '#5d8cff',
  nbaLight: '#2f64ee',
  nfl: '#ff4d6d',
  nflLight: '#e11d48',

  live: '#ef4444',
  liveGlow: 'rgba(239, 68, 68, 0.2)',

  goal: '#facc15',
  redCard: '#ef4444',
  yellowCard: '#facc15',

  white: '#ffffff',
  black: '#000000',

  tabBar: '#080d18',
  tabBarBorder: '#162033',

  card: '#0d1422',
  cardBorder: '#182235',
};

export const SportColors = {
  futebol: {
    primary: '#52ff27',
    secondary: '#27d915',
    tint: 'rgba(82, 255, 39, 0.12)',
  },
  nba: {
    primary: '#5d8cff',
    secondary: '#2f64ee',
    tint: 'rgba(93, 140, 255, 0.14)',
  },
  nfl: {
    primary: '#ff4d6d',
    secondary: '#e11d48',
    tint: 'rgba(255, 77, 109, 0.14)',
  },
};
